import { useMapEvents } from "react-leaflet";
export const RightClickMapHandler = ({ setMenuPosition }) => {
    const map = useMapEvents({
        contextmenu(e) {
            const containerPoint = map.latLngToContainerPoint(e.latlng);
            setMenuPosition({
                x: containerPoint.x,
                y: containerPoint.y,
                latlng: e.latlng,
            });
        },
    });
    return null;
};
